import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as friendActions from 'services/friends/actions'
import * as friend from 'services/friends/selectors'
import * as user from 'services/user/selectors'
import SidebarWidget from 'components/sidebar/SidebarWidget'
import styles from './_friendWidget.css'
import ItemRow from 'components/layout/ItemRow'
import Friend from './Friend'

const mapStateToProps = (state) => ({
  myFriends: friend.selectFriends(state),
  noFriends: friend.selectNoFriends(state),
  myFriendsLoading: friend.selectFriendsLoading(state),
  totalFriends: friend.selectTotalFriends(state),
  userId: user.selectUserId(state),
})

const mapDispatchToActions = {
  ...friendActions,
}

export class FriendWidget extends Component {
  static propTypes = {
    myFriends: PropTypes.array,
    noFriends: PropTypes.bool,
    myFriendsLoading: PropTypes.bool,
    totalFriends: PropTypes.number,
    userId: PropTypes.number,
    getFriends: PropTypes.func,
  }

  state = {
    detailsToDisplay: null,
  }

  componentDidMount () {
    const { userId, getFriends } = this.props
    getFriends(userId, 8)
  }

  handleToggleThumbnail = (friendId) => {
    this.setState({
      detailsToDisplay: friendId,
    })
  }

  render () {
    const {
      myFriends,
      totalFriends,
      noFriends,
    } = this.props

    const { detailsToDisplay } = this.state

    const friendNodes = myFriends.map((friendInfo, i) =>
      <Friend
        key={i}
        onHover={this.handleToggleThumbnail}
        showDetails={detailsToDisplay === friendInfo.id}
        friend={friendInfo} />
    )

    return (
      <SidebarWidget>
        <div className={styles.header}>
          <h3>
            <FormattedMessage id='home.friends.title' defaultMessage='Friends' />
            <Link className={styles.friendTotalLink} to='/people/friends'>
              ({totalFriends})
            </Link>
          </h3>
          <div className={styles.linkContainer}>
            <Link className={styles.link} to='/people/friends'>
              <FormattedMessage id='home.friends.view' defaultMessage='View All' />
            </Link>
            <Link className={styles.link} to='/people/friends/find'>
              <FormattedMessage id='home.friends.find' defaultMessage='Find Friends' />
            </Link>
          </div>
        </div>

        {noFriends ?
          <FormattedMessage
            id='home.friends.none'
            defaultMessage='You have not added any friends yet.' /> : null}

        <ItemRow nodes={friendNodes} xsCols={4} cols={4} />
      </SidebarWidget>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(FriendWidget)



// WEBPACK FOOTER //
// ./src/components/home/friends/FriendWidget.jsx